module.exports = __webpack_public_path__ + "static/media/xmas-background-modern.742e2ff5.svg";